<svg class="icon {class}" title={title}>

    <use xlink:Href={'/icons.svg#'+iconId} />

</svg>

<style>

    .icon {
        display: inline-block;
        fill: var(--icon-color);
        height: 1rem;
        width: 1rem;
    }

    .icon--small {
        display: inline-block;
        fill: var(--icon-color);
        height: 0.8rem;
        width: 0.8rem;
    }

</style>

<script>
    export default {
        data() {
            return {
                iconId: 'home',
                title: '',
                class: ''
            }
        }
    }
</script>